import { render, staticRenderFns } from "./ContractFondsanteileMobile.vue?vue&type=template&id=1e51829d&scoped=true&"
import script from "./ContractFondsanteileMobile.vue?vue&type=script&lang=ts&"
export * from "./ContractFondsanteileMobile.vue?vue&type=script&lang=ts&"
import style0 from "./ContractFondsanteileMobile.vue?vue&type=style&index=0&id=1e51829d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51829d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VDivider,VIcon,VRow})
